import { ref } from "vue"
import { defineStore } from "pinia"
import jobBoardApi from "../api/job-board.js"
import { setAuthState } from "../composables/auth";

const { isAuthenticated } = setAuthState();

export const useJobAlertsStore = defineStore("jobAlerts", () => {
    // State
    const isEditModalVisible = ref(false)
    const isDeleteModalVisible = ref(false)
    const jobAlertExist = ref(false)
    const loadingJobAlerts = ref(false)
    const switchPosition = ref(false)
    const jobAlert = ref(null)
    const jobAlerts = ref([])
    const jobBoardUserSettings = ref(null)
    // Actions
    const setCurrentJobAlert = (item) => {
        jobAlert.value = item
    }

    const showEditFiltersModal = (item) => {
        setCurrentJobAlert(item)
        isEditModalVisible.value = true
    }

    const showDeleteFiltersModal = (item) => {
        setCurrentJobAlert(item)
        isDeleteModalVisible.value = true
    }

    const fetchJobAlerts = async() => {
        if(!isAuthenticated()) return;

        loadingJobAlerts.value = true
        try { 
            jobAlerts.value = await jobBoardApi.getFilters();
        } finally {
            loadingJobAlerts.value = false
        }
    }

    const checkIfJobAlertExist = async (jobSearchFilters) => {
        switchPosition.value = false
        const { job_title, location, ...rest } = jobSearchFilters
        const filterData = {
            role: job_title.toLowerCase() || "Title not set",
            location: location || "Not set",
            meta: {
                email_frequency: 'weekly',  // Default value
                ...rest
            }
        }

        await fetchJobAlerts()

        // Check if a job alert with the same filters already exists
        const filterExist = jobAlerts.value.find((item) =>
            ['role', 'location'].every(key => item[key] === filterData[key]) &&
            Object.keys(filterData.meta)
                .filter(key => key !== 'email_frequency') // Ignore this field when comparing
                .every(key => item.meta[key] === filterData.meta[key])
        )
        if (filterExist) {
            jobAlert.value = filterExist
            switchPosition.value = filterExist.active
            jobAlertExist.value = true
        } else {
            jobAlert.value = filterData
            jobAlertExist.value = false
        }
    }


    const saveCurrentJobAlert = async() =>{
        switchPosition.value = true
        await jobBoardApi.saveFilters(jobAlert.value);
        await fetchJobAlerts()

        jobAlertExist.value = true
        jobAlert.value = jobAlerts.value.at(-1)
    }

    const updateJobAlertById = async (jobAlertId, data) => {
        await jobBoardApi.updateFilter(jobAlertId, data);
        const findJobAlertIndexById = jobAlerts.value.findIndex(item => item.id === jobAlertId)
        const updateJobAlertIndex = { ...jobAlerts.value[findJobAlertIndexById], ...data };
        jobAlerts.value.splice(findJobAlertIndexById, 1, updateJobAlertIndex);

        jobAlert.value = jobAlerts.value.find(item => item.id === jobAlertId);
        switchPosition.value = jobAlert.value.active;
        isEditModalVisible.value = false;
    }

    const deleteJobAlert = async(jobAlertId) => {
        await jobBoardApi.deleteFilter(jobAlertId)
        const jobAlertIndex = jobAlerts.value.findIndex(item => item.id === jobAlertId)
        jobAlerts.value.splice(jobAlertIndex, 1)

        isDeleteModalVisible.value = false
        switchPosition.value = false
        jobAlertExist.value = false
    }

    const fetchJobUserSettings = async () => {
        jobBoardUserSettings.value = await jobBoardApi.getPersonalizedJobRecommendations()
    };

    const getJobBoardUserSettingsByKey = (key) => {
        const element = jobBoardUserSettings.value.find(el => el.key === key)
        return element.value
    }

    const updateUserSettings = async(key, value) =>{
        await jobBoardApi.updatePersonalizedJobRecommendations({key, value});
    }

    return {
        jobAlerts,
        switchPosition,
        jobAlert,
        loadingJobAlerts,
        isEditModalVisible,
        isDeleteModalVisible,
        jobAlertExist,
        jobBoardUserSettings,

        fetchJobAlerts,
        updateJobAlertById,
        deleteJobAlert,
        showEditFiltersModal,
        showDeleteFiltersModal,
        updateUserSettings,
        saveCurrentJobAlert,
        checkIfJobAlertExist,
        fetchJobUserSettings,
        getJobBoardUserSettingsByKey
    }
})
